import Figure from "~/components/figure"
import ZoomInBanner from "../commentaries/zoomIn/banner"
import CurveDetectorBanner from "../circuits/curve-detector/banner"
import CurveCircuitBanner from "../circuits/curve-circuit/banner"
import EarlyVisionBanner from "../commentaries/earlyVision/banner"
import { Badge, Icon } from "evergreen-ui"
import { Redirect } from "react-router-dom"

export default class BigToc extends Component {
  state = { to: null }
  render() {
    const { to } = this.state
    const { tocWidth } = this.props

    if (to) {
      return <Redirect to={to} />
    }

    const Chapter = ({ noMargin = false, index, children }) => (
      <React.Fragment>
        <Surface marginTop={noMargin ? 0 : 40} />
        <Surface
          // position="sticky"
          zIndex={1000}
          top={0}
          paddingTop={40}
          paddingLeft={40}
          // transform="translateY(-1px)"
          // background="rgba(250, 250, 250, 1)"
          opacity={1}
          paddingBottom={0}
          // borderBottom
          borderTop={index > 1}
          width="100%"
        >
          <Surface flexFlow="row">
            <Text fontSize={30} fontWeight={600}>
              {children}
            </Text>
            <Text
              fontSize={30}
              color="rgba(0, 0, 0, 0.4)"
              fontWeight={600}
              marginLeft={20}
            >
              Chapter {index}
            </Text>
          </Surface>
        </Surface>
      </React.Fragment>
    )

    const hoverColor = "#0a85ea"
    const baseColor = "rgba(0, 0, 0, 0.8)"

    const Section = ({ index, sub, children, href }) => (
      <Surface
        paddingLeft={80}
        marginTop={40}
        onClick={() => {
          if (href) {
            this.setState({ to: href })
          }
        }}
        opacity={href ? 1 : 0.4}
        cursor={href && "pointer"}
      >
        {hovering => (
          <React.Fragment>
            <Surface flexFlow="row" alignItems="center">
              <Text fontSize={30} color="rgba(0, 0, 0, 0.4)" fontWeight={600}>
                {index}
              </Text>
              <Text
                fontSize={30}
                fontWeight={600}
                transition="all 300ms ease-out"
                color={href && hovering ? hoverColor : baseColor}
                marginLeft={10}
              >
                {children}
              </Text>
              {href && (
                <Icon
                  icon="chevron-right"
                  size={24}
                  color={hovering ? hoverColor : baseColor}
                  transition="all 600ms ease-out"
                  marginLeft={5}
                  transform={"translateX(" + (hovering ? 10 : 0) + "px)"}
                  marginTop={3}
                />
              )}
              {!href && (
                <Badge marginLeft={20} size={300}>
                  Coming Soon
                </Badge>
              )}
            </Surface>
            <Text
              fontSize={24}
              marginTop={15}
              fontWeight={400}
              lineHeight={1.3}
            >
              {sub}
            </Text>
          </React.Fragment>
        )}
      </Surface>
    )

    return (
      <Surface
        width="100%"
        position="relative"
        borderLeft
        width={window.innerWidth - tocWidth}
        marginLeft={tocWidth}
      >
        <Chapter index={1} noMargin>
          Introduction
        </Chapter>
        <Section
          index={1.1}
          sub={
            "Three claims we believe warrant zooming into neural network circuits."
          }
          href="/commentaries/zoom-in"
        >
          Zoom In
        </Section>

        <Figure fullWidth>
          <ZoomInBanner />
        </Figure>

        <Section
          index={1.2}
          sub={
            "An interactive tool for reproducing circuits or discovering new ones."
          }
        >
          Circuit Designer
        </Section>
        <Figure fullWidth>
          <img src={require("./designer.png")} width={1250} />
        </Figure>

        <Section index={1.3} sub={"Techniques for undertanding circuits."}>
          Techniques
        </Section>
        <Section
          index={1.4}
          sub={
            "An interactive tool for reproducing circuits or discovering new ones."
          }
        >
          Deep Micrographia
        </Section>

        <Chapter index={2}>Early Vision</Chapter>

        <Section
          index={2.1}
          sub={"A walkthrough of early vision in InceptionV1"}
        >
          Overview of Early Vision
        </Section>
        <Section
          index={2.2}
          sub={
            "A detailed look at a nearly universally occuring family of units that form an important part of early vision networks."
          }
          href="/research/curve-detectors"
        >
          Curve Detector
        </Section>
        <Surface width="100%">
          <CurveDetectorBanner />
        </Surface>

        <Section
          index={2.3}
          sub={
            "A detailed look at circuits that implement curve detectors across models."
          }
          href="/research/curve-circuit"
        >
          Curve Circuit
        </Section>
        <Surface width="100%">
          <CurveCircuitBanner />
        </Surface>
        <Chapter index={3}>Motifs</Chapter>
        <Section
          index={3.1}
          sub={
            "A look at the recuring structures that appear across vision networks."
          }
        >
          Introduction to Motifs
        </Section>
        <Section index={3.2}>The Dog Head Circuit</Section>
        <Section index={3.3}>The Role of Negative Weights</Section>
        <Section index={3.4}>Shifting</Section>
        <Section index={3.5}>Union</Section>
        <Section index={3.6}>Neuron Family Equivariance</Section>
        <Section index={3.6}>Superposition</Section>
        <Chapter index={4}>Circuit Editing</Chapter>
        <Section
          index={4.1}
          sub={
            "Controlling specific neural network behavior by hand-editing its weights."
          }
        >
          Introduction to Circuit Editing
        </Section>
        <Section
          index={4.2}
          sub={
            "Stopping a coin-run agent from being able to gather coins using circuit editing."
          }
        >
          Editing an RL Agent
        </Section>
        <Surface marginY={30} />
      </Surface>
    )
  }
}

/*

        <Surface flexFlow="row" gridColumn="page" marginTop={80}>
          <Text fontSize={30} fontWeight={600}>
            An Overview of Early Vision
          </Text>
          <Text fontSize={30} opacity={0.4} fontWeight={600} marginLeft={20}>
            Chapter 2
          </Text>
        </Surface>

        <Text
          fontSize={24}
          marginTop={15}
          fontWeight={400}
          lineHeight={1.3}
          width={800}
          gridColumn="page"
        >
          A walkthrough of early vision in InceptionV1
        </Text>

        <Surface width="100%">
          <EarlyVisionBanner />
        </Surface>

        <Surface flexFlow="row" gridColumn="page" marginTop={80}>
          <Text fontSize={30} fontWeight={600}>
            Circuit Designer
          </Text>
          <Text fontSize={30} opacity={0.4} fontWeight={600} marginLeft={20}>
            Chapter 3
          </Text>
        </Surface>

        <Text
          fontSize={24}
          marginTop={15}
          fontWeight={400}
          lineHeight={1.4}
          width={800}
          gridColumn="page"
        >
          An interactive tool for reproducing circuits or discovering new ones.
        </Text>
        <Surface flexFlow="row" gridColumn="page" marginTop={80}>
          <Text fontSize={30} fontWeight={600}>
            Curve Detectors
          </Text>
          <Text fontSize={30} opacity={0.4} fontWeight={600} marginLeft={20}>
            Chapter 4
          </Text>
        </Surface>

        <Text
          fontSize={24}
          marginTop={15}
          fontWeight={400}
          lineHeight={1.4}
          width={800}
          gridColumn="page"
        >
          A detailed look at a nearly universally occuring family of units that
          form an important part of early vision networks.
        </Text>
        <Surface width="100%">
          <CurveDetectorBanner />
        </Surface>
        <Surface flexFlow="row" gridColumn="page" marginTop={80}>
          <Text fontSize={30} fontWeight={600}>
            Curve Circuits
          </Text>
          <Text fontSize={30} opacity={0.4} fontWeight={600} marginLeft={20}>
            Chapter 5
          </Text>
        </Surface>
        <Text
          fontSize={24}
          marginTop={15}
          fontWeight={400}
          lineHeight={1.4}
          width={800}
          gridColumn="page"
        >
          A detailed look at circuits that implement curve detectors across models.
        </Text>
        <Figure />

        <Surface flexFlow="row" gridColumn="page" marginTop={80}>
          <Text fontSize={30} fontWeight={600}>
            Oriented Dog Heads
          </Text>
          <Text fontSize={30} opacity={0.4} fontWeight={600} marginLeft={20}>
            Chapter 6
          </Text>
        </Surface>
        <Figure fullWidth />

        <Surface flexFlow="row" gridColumn="page" marginTop={80}>
          <Text fontSize={30} fontWeight={600}>
            Circuit Editing
          </Text>
          <Text fontSize={30} opacity={0.4} fontWeight={600} marginLeft={20}>
            Chapter 7
          </Text>
        </Surface>
        <Text
          fontSize={24}
          marginTop={15}
          fontWeight={400}
          lineHeight={1.4}
          width={800}
          gridColumn="page"
        >
          Controlling specific neural network behavior by hand-editing its
          weights.
        </Text>
        <Figure fullWidth />

        <Surface flexFlow="row" gridColumn="page" marginTop={80}>
          <Text fontSize={30} fontWeight={600}>
            Selectively Disabling an RL Agent with Circuit Editing
          </Text>
          <Text fontSize={30} opacity={0.4} fontWeight={600} marginLeft={20}>
            Chapter 8
          </Text>
        </Surface>
        <Text
          fontSize={24}
          marginTop={15}
          fontWeight={400}
          lineHeight={1.4}
          width={800}
          gridColumn="page"
        >
          Stopping a coin-run agent from being able to gather coins using
          circuit editing.
        </Text>
        <Figure fullWidth>
          <img src={require("./rl.png")} width={1000} />
        </Figure>

        <Surface flexFlow="row" gridColumn="page" marginTop={80}>
          <Text fontSize={30} fontWeight={600}>
            Motifs
          </Text>
          <Text fontSize={30} opacity={0.4} fontWeight={600} marginLeft={20}>
            Chapter 9
          </Text>
        </Surface>
        <Text
          fontSize={24}
          marginTop={15}
          fontWeight={400}
          lineHeight={1.4}
          width={800}
          gridColumn="page"
        >
          Recurring structures that neural networks use to implement circuits.
        </Text>

        <Figure fullWidth />
        <Surface marginY={20} />
        */
